import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, FormField, Header, Input } from "components";

import { ArrowRight } from "iconsax-react";

import styles from "./styles.module.css";
import useColors from "utils/Colors";
import { CloseIconGrey } from "assets/images";
import { GetUserCredit } from "services/account";

import { useFormik } from "formik";
import * as Yup from "yup";
import { _getFieldStatus } from "utils/_helpers";
import { toast } from "react-toastify";

const initialValues = {
  phone_number: undefined,
  national_code: undefined,
};

const CheckCredit = () => {
  const navigate = useNavigate();
  const Colors = useColors();

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState();

  const validationSchema = Yup.object({
    phone_number: Yup.string()
      .matches(
        /^(\+98|0098|98|0)?9\d{9}$/g,
        "لطفا یک شماره موبایل معتبر وارد نمایید"
      )
      .required("وارد کردن این فیلد الزامی است"),
    national_code: Yup.string()
      .min("10", "کدملی باید ۱۰ رقم باشد")
      .max("10", "کدملی باید ۱۰ رقم باشد")
      .required(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);
      GetUserCredit(values)
        .then((result) => {
          setLoading(false);
          setResult(result);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response.status == 400) {
            toast.error("اطلاعات یافت نشد");
          }
        });
    },
  });

  return (
    <main className={styles.container}>
      {/* Header */}
      <Header
        title="بررسی اعتبار باقیمانده"
        right={
          <ArrowRight
            size={24}
            color={Colors.Grey[1]}
            onClick={() => navigate(-1)}
          />
        }
      />
      {/* X Header X*/}
      {/* Content */}
      <div className={styles.content}>
        {result ? (
          <>
            <div
              className="d-flex align-items-center justify-content-between "
              style={{ marginBottom: 16 }}
            >
              <span>نام کاربر</span>
              <span>
                <strong>{result?.full_name}</strong>
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ marginBottom: 48 }}
            >
              <span>موجودی اعتبار</span>
              <span>
                <strong>{result?.balance?.toLocaleString()}</strong>{" "}
                تومان
              </span>
            </div>
          </>
        ) : (
          <>
            {" "}
            <h4 className={styles.title}>
              برای بررسی اعتبار موارد زیر را وارد نمایید
            </h4>
            <div className={styles.field_container}>
              <FormField
                title="شماره موبایل"
                control={
                  <Input
                    id={"phone-input"}
                    type={"tel"}
                    placeholder="0912xxxxxxx"
                    onBlur={(e) =>
                      formik.setFieldValue(
                        "phone_number",
                        e.target.value.replace(
                          /[٠-٩۰-۹]/g,
                          (a) => a.charCodeAt(0) & 15
                        )
                      )
                    }
                    status={_getFieldStatus(formik, "phone_number")}
                    left={
                      <img
                        src={CloseIconGrey}
                        width={20}
                        onClick={(e) =>
                          (document.querySelector("#phone-input").value = "")
                        }
                      />
                    }
                  />
                }
              />
            </div>
            <div className={styles.field_container}>
              <FormField
                title="کدملی"
                control={
                  <Input
                    id={"national-id-input"}
                    placeholder="کد ملی را وارد نمایید"
                    inputMode="numeric"
                    onBlur={(e) =>
                      formik.setFieldValue(
                        "national_code",
                        e.target.value.replace(
                          /[٠-٩۰-۹]/g,
                          (a) => a.charCodeAt(0) & 15
                        )
                      )
                    }
                    status={_getFieldStatus(formik, "national_code")}
                    left={
                      <img
                        src={CloseIconGrey}
                        width={20}
                        onClick={(e) =>
                          (document.querySelector("#national-id-input").value =
                            "")
                        }
                      />
                    }
                  />
                }
              />
            </div>
          </>
        )}
        <Button
          loading={loading}
          onClick={() => {
            if (result) {
              setResult();
              formik.resetForm();
            } else {
              formik.submitForm();
            }
          }}
        >
          {result ? "بررسی مجدد" : "تایید"}
        </Button>
      </div>
      {/* X Content X*/}
    </main>
  );
};

export default CheckCredit;
